import { lazyNamed } from 'src/utils/lazyNamed';

export const BroadcastProducts = {
  AdMedia: lazyNamed(() => import('./pages/AdMedia'), 'AdMedia'),

  AdPlacements: lazyNamed(() => import('./pages/AdPlacements'), 'AdPlacements'),
  AdPlacementForm: lazyNamed(() => import('./pages/AdPlacementForm'), 'AdPlacementForm'),

  AdTypes: lazyNamed(() => import('./pages/AdTypes'), 'AdTypes'),

  Products: lazyNamed(() => import('./pages/Products'), 'Products'),
  ProductForm: lazyNamed(() => import('./pages/ProductForm'), 'ProductForm'),

  AdPrices: lazyNamed(() => import('./pages/AdPrices'), 'AdPrices'),
  CreateAdPriceForm: lazyNamed(() => import('./pages/CreateAdPriceForm'), 'CreateAdPriceForm'),
  EditAdPriceForm: lazyNamed(() => import('./pages/EditAdPriceForm'), 'EditAdPriceForm'),
};
